export default __webpack_public_path__ + "static/media/credit-card.d54e0387.svg";